import {Component, Input, Inject, OnChanges, OnInit, SimpleChanges, Output, EventEmitter } from 'ng-metadata/core';
import {ResourceRecommenderService} from './resourceRecommender.service';
const slice = require('lodash/slice');
const map = require('lodash/map');
const flatMap = require('lodash/flatMap');
const cloneDeep= require('lodash/cloneDeep');
const min = require('lodash/min');
const forEach = require('lodash/forEach');
const maxResources = 3;

import {IRecommendedResource} from './recommendedResource';
import {MediaQueries} from '../../infra/mediaQueries.service';
import {PrimolyticsService, beacon} from '../../analytics/primolytics.service';
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";
import {SharedSessionStorage} from '../../infra/sharedSessionStorage.service';

const get = require('lodash/get');

interface IRecommendedResourceSlot{
    resourceType:string;
    resources: IRecommendedResource[];
}


@Component({
    selector: 'prm-resource-recommender',
    templateUrl: 'components/search/resourceRecommender/resource-recommender.html',
})

export class PrmResourceRecommender implements OnChanges, OnInit{
    @Input('query') query:string;
    private _isBanner: boolean;
    private recommendedResources: IRecommendedResourceSlot[] = [];
    private previewResources: IRecommendedResource[] = [];
    private banner: IRecommendedResourceSlot;
    private previewClass: string;
    private static previewClassByLength = {
        1: 'flex',
        2: 'flex-50',
        3: 'flex-33'
    };
    @Output() private resourceRecommenderEvent = new EventEmitter<boolean>();

    constructor(private resourceRecommenderService: ResourceRecommenderService,
                @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService,
                private mediaQueries:MediaQueries,
                private sharedSessionStorage: SharedSessionStorage,
                private primolyticsService: PrimolyticsService,
                private configurationUtil: ConfigurationUtil) {
            
            this._isBanner = this.sharedSessionStorage.getItem('showBanner') === 'false' ? false : true;
    }


    ngOnInit() {
    }

    get isBanner() {
        return this._isBanner;
    }

    set isBanner(value) {
        this._isBanner = value;
    }

    public closeBanner() {
        this.isBanner = false;
        this.sharedSessionStorage.setItem('showBanner', 'false');
    }


    ngOnChanges(changes: SimpleChanges ) {
        if(!changes['query']) {
            return;
        }
        let currentQuery = changes['query'].currentValue;
        if(currentQuery) {
            this.resourceRecommenderService.getRecommendations(currentQuery).then((res: IRecommendedResourceSlot[])=> this.parseRecommendations(res));
        }
        this.resourceRecommenderService.resetRecommendetions();
    }

    showAdditionalResourcesLink() {
        let mResources;
        if(this.mediaQueries.gtxs){
            mResources = maxResources;
        }
        else {
            mResources = 1;
        }
        return this.recommendedResources.length> mResources;
    }

    numOfResources() {
        return this.recommendedResources.length;
    }
    parseRecommendations(data) {
        let res:IRecommendedResourceSlot[] = data.data;
        this.resourceRecommenderEvent.emit(res && res.length>0);
        if(res && res.length > 0){
			let bannersList = res.filter( recommendationField => recommendationField.resourceType === 'banner');
			res = res.filter( recommendationField => recommendationField.resourceType !== 'banner'); // remove banners from resource recommendations
			this.banner = bannersList ? get(bannersList, '[0].resources[0]', null) : null; // extract banners from resource recommendations
		}
		if(!res || res.length ===0) {
            this.recommendedResources = [];
            this.previewResources = [];
            return;
        }
        res = cloneDeep(res);//defensively copying because we are going to change fields of result
        this.recommendedResources = flatMap(res, (r) => flattenResourceRecommenderSlot(r));
		

        for (let recommendationField of res) {
            this.resourceRecommenderService.setRecommendationCount(recommendationField.resourceType, recommendationField.resources.length);
        }
        let rLength = res.length;
        let shortResPartition = [];

        let budget = maxResources;
        let i=0;
        while(i< rLength && budget >0) {
            let numbersCanTake = i ===0 ? 2 : 1;
            let numbersToTake = min([res[i].resources.length,numbersCanTake]);
            shortResPartition.push(numbersToTake);
            budget -=  numbersToTake;
            i++;
        }


        // if there are more than 3 slots or if there are 2 slots and priority resource is bigger than one this can not happen.
        // this can just happen when there is either one slot or 2 slots and the firs slot haes just one resource
        if(budget >0) {
            let rIndex = rLength - 1;
            let numbersToTake = min([res[rIndex].resources.length - shortResPartition[rIndex], budget]);
            if(numbersToTake > 0) {// if there is more than we took
                shortResPartition[rIndex] += numbersToTake;
            }

        }
        let shortRes = flatMap(shortResPartition, (v,index) => flattenResourceRecommenderSlot(res[index],v));
        this.previewResources = shortRes;
        this.previewClass = PrmResourceRecommender.previewClassByLength[shortRes.length];
        this.handleDisplayAlwaysParam();
        this.resourceRecommenderDisplayedBeacon();
    }
    resourceRecommenderLimit() {
        if(this.mediaQueries.gtxs){
            return null;
        }
        else {
            return 1;
        }
    }

    openFullView() {
        this.reportBeacon("openFullView");
        this.$mdDialog.show({
            // template: templateString,
            templateUrl: 'components/search/resourceRecommender/resource-recommender-dialog-template.html',
            locals: {
                dialog: this.$mdDialog,
                mediaQueries: this.mediaQueries,
                query: this.query,
                resources: this.recommendedResources
        },
        bindToController: true,
            clickOutsideToClose: true,
            fullscreen: true,
            escapeToClose: true,
            controllerAs: '$ctrl',
            controller: () => {}
        });
    }

    public displayBanner() {
        return this.isBanner && this.banner;
    }

    public handleDisplayAlwaysParam() {
        this.recommendedResources.sort(function(a,b){
			let display_always_a = a.display_always ? a.display_always.toLowerCase().trim() : '';
			let display_always_b = b.display_always ? b.display_always.toLowerCase().trim() : '';
			if(display_always_a === display_always_b){
				return 0;
			}
			if(display_always_a === 'true'){
				return -1;
			}
			if(display_always_b === 'true'){
				return 1;
			}
			return 0;
        });
		if(this.previewResources.length > 0){
			let displayAlwaysResources = this.recommendedResources.filter(recommendationField => recommendationField.display_always && recommendationField.display_always.toLowerCase().trim() === 'true');
			let previewResourcesLength = this.previewResources.length;
			this.previewResources = displayAlwaysResources.concat(this.previewResources);
			this.previewResources = this.previewResources.filter((v,i,a)=>a.findIndex(v2=>(JSON.stringify(v2) === JSON.stringify(v)))===i);
			this.previewResources = this.previewResources.slice(0,previewResourcesLength);
		}
    }


    @beacon({'p':'brief', 'op': 'resourceRecommenderFullView'})
    private reportBeacon(resource) {

    }

    @beacon({'p':'brief', 'op': 'resourceRecommenderDisplayed'})
    private resourceRecommenderDisplayedBeacon() {}
}



function flattenResourceRecommenderSlot(resourceSlot : IRecommendedResourceSlot,elementNum?: number) {
    let res = elementNum? slice( resourceSlot.resources, 0,elementNum):  resourceSlot.resources;
    forEach(res, (r: IRecommendedResource)=> r.resourceType = resourceSlot.resourceType);
    return res;
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/resourceRecommender/resourceRecommender.directive.ts